import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-portal-back',
  templateUrl: './portal-back.component.html'
})
export class PortalBackComponent {
  public titulo: string = "Inicio";
  public errorMessage;
  public urlTree;
  public userinfo: string;

  user: User;

  constructor(private http: HttpClient, private router: Router, private globals: Globals, private cookies: CookieService) {
    this.urlTree = this.router.parseUrl(this.router.url);
    this.globals.path = this.urlTree.root.children.primary.segments[0].path;
    this.userinfo = this.urlTree.queryParams['c'];
    if (this.userinfo == "") {
      var token = this.cookies.get("tokensessionFuncionario");
      if (token == "") {
        window.location.href = environment.redirecturl;
      }
      else {
        this.http.get<any>(`${environment.baseUrl}v1/sessionfuncionario/1?token=` + this.cookies.get("tokensessionFuncionario"))
          .subscribe({
            next: data => {
              this.user = data as User;

              this.globals.tipoDocumento = this.user.tipoDocumento;
              this.globals.numIdentificacion = this.user.numIdentificacion;
              this.globals.nombres = this.user.nombres;
              this.globals.apellidos = this.user.apellidos;
              this.globals.seccional = this.user.seccional;
              this.globals.idSeccional = this.user.idSeccional;
              this.globals.dependencia = this.user.dependencia;
              this.globals.idDependencia = this.user.idDependencia;
              this.globals.correo = this.user.correo;
              this.globals.activo = this.user.activo;
              this.globals.roles = this.user.rolesAutorizados.split(",");

              for (let i = 0; i < this.globals.roles.length; i++) {
                if (this.globals.roles[i] == "3244") {
                  this.globals.r3244 = true;
                }
                if (this.globals.roles[i] == "3246") {
                  this.globals.r3246 = true;
                }
                if (this.globals.roles[i] == "3247") {
                  this.globals.r3247 = true;
                }
              }
            },
            error: error => {
              this.errorMessage = error.message;
            }
          })
      }      
    }
    else {
      this.urlTree = this.router.parseUrl(this.router.url);
      this.globals.path = this.urlTree.root.children.primary.segments[0].path;
      this.cookies.set("pathFuncionario", this.urlTree.root.children.primary.segments[0].path);
      this.userinfo = this.urlTree.queryParams['c'];
      this.globals.userinfo = this.userinfo;
      this.user = new User();
      this.user.infouser = this.userinfo;
      const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
      this.http.post<any>(`${environment.baseUrl}v1/user`, this.user, { headers })
        .subscribe({
          next: data => {
            this.user = data as User;
            this.http.get<any>(`${environment.baseUrl}v1/user/1?idtoken=` + this.user.idToken + "&clientid=" + this.user.clientId)
              .subscribe({
                next: data => {
                  this.user = data as User;
                  this.globals.tipoDocumento = this.user.tipoDocumento;
                  this.globals.numIdentificacion = this.user.numIdentificacion;
                  this.globals.nombres = this.user.nombres;
                  this.globals.apellidos = this.user.apellidos;
                  this.globals.seccional = this.user.seccional;
                  this.globals.idSeccional = this.user.idSeccional;
                  this.globals.dependencia = this.user.dependencia;
                  this.globals.idDependencia = this.user.idDependencia;
                  this.globals.correo = this.user.correo;
                  this.globals.activo = this.user.activo;
                  this.globals.roles = this.user.rolesAutorizados.split(",");

                  for (let i = 0; i < this.globals.roles.length; i++) {
                    if (this.globals.roles[i] == "3244") {
                      this.globals.r3244 = true;
                    }
                    if (this.globals.roles[i] == "3246") {
                      this.globals.r3246 = true;
                    }
                    if (this.globals.roles[i] == "3247") {
                      this.globals.r3247 = true;
                    }
                  }

                  const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
                  this.http.post<string>(`${environment.baseUrl}v1/sessionfuncionario`, this.user, { headers })
                    .subscribe({
                      next: data => {
                        this.cookies.set("tokensessionFuncionario", data, 1, environment.raiz, environment.dominio, false, "Lax");
                      },
                      error: error => {
                      }
                    })
                },
                error: error => {
                  this.errorMessage = error.message;
                }
              })
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
  }

  goManageImport() {
    this.router.navigate(["/manage-import"]);
  }

  goReport() {
    this.router.navigate(["/generate-report"]);
  }

  goFinishImport() {
    this.router.navigate(["/finish-import"]);
  }
}

class User {
  idToken: string;
  clientId: string;
  tipoDocumento: string;
  numIdentificacion: string;
  nombres: string;
  apellidos: string;
  seccional: string;
  idSeccional: string;
  dependencia: string;
  idDependencia: string;
  correo: string;
  activo: string;
  rolesAutorizados: string;
  infouser: string;
}
